export default {
	apiKey: "AIzaSyBaujWhVXEmpiN45jJAmhKUnXXfnEjH1S8",
	authDomain: "ares-dev-app.firebaseapp.com",
	databaseURL: "https://ares-dev-app.firebaseio.com",
	projectId: "ares-dev-app",
	storageBucket: "ares-dev-app.appspot.com",
	messagingSenderId: "306608194601",
	appId: "1:306608194601:web:0ad1fc98a30d1e3bb1c838",
	measurementId: "G-ZBD2CGX51B"
}